<script lang="ts" setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const keyword = ref('')

function handleSearch() {
  if (!keyword.value.trim())
    return
  router.push({ name: 'search', query: { keyword: keyword.value.trim() } })
  keyword.value = ''
}
</script>

<template>
  <div class="relative" style="width: 164px; height: 32px">
    <input
      v-model="keyword"
      type="text"
      placeholder="search"
      style="width: 100%; height: 100%; padding-left: 32px; padding-right: 12px; background: #F2F2F2; border: none; border-radius: 16px; font-size: 14px; color: #333; outline: none; box-sizing: border-box"
      @keydown.enter="handleSearch"
    >
    <svg
      style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%); width: 14px; height: 14px; color: #999"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z" />
    </svg>
  </div>
</template>
